import { render, staticRenderFns } from "./DraggableTable.vue?vue&type=template&id=03ea9269&"
import script from "./DraggableTable.vue?vue&type=script&lang=js&"
export * from "./DraggableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports